import _defineProperty from '../../../node_modules/@babel/runtime/helpers/esm/defineProperty.js';
import React__default from 'react';
import PropTypes__default from 'prop-types';
import { useBreakpoints } from '../../hooks/useBreakpoints.js';
import { makeStyles, useTheme, Box, Typography } from '@material-ui/core';
import { retrieveContentfulImage } from '../../common/image.js';
import CustomRichTextFromMarkdown from '../../widgets/text/CustomRichTextFromMarkdown.js';
import { LazyLoadImage } from 'react-lazy-load-image-component';

var useStyles = makeStyles(function (theme) {
  return {
    wrapper: {
      width: "100%"
    },
    item: _defineProperty({
      position: "relative",
      width: "50%"
    }, theme.breakpoints.down("sm"), {
      width: "100%"
    }),
    image: {
      width: "100%",
      borderRadius: theme.spacing(1.75),
      objectFit: "cover"
    },
    imageTitle: {
      marginTop: theme.spacing(1.5)
    },
    stepIndicator: _defineProperty(_defineProperty({
      background: theme.palette.primary[100],
      borderRadius: "100%",
      width: theme.spacing(7.5),
      height: theme.spacing(7.5),
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignSelf: "end",
      zIndex: 1
    }, theme.breakpoints.up("sm"), {
      position: "absolute",
      top: -theme.spacing(1.5),
      left: -theme.spacing(6)
    }), theme.breakpoints.down("xs"), {
      position: "absolute",
      top: -theme.spacing(2.25),
      left: -theme.spacing(6)
    }),
    title: {
      position: "relative",
      zIndex: 2
    }
  };
});
var _StepIndicator = function StepIndicator(_ref) {
  var index = _ref.index,
    className = _ref.className;
  _StepIndicator.propTypes = {
    index: PropTypes__default.string,
    className: PropTypes__default.any
  };
  return /*#__PURE__*/React__default.createElement(Box, {
    className: className
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "span"
  }, index));
};
var NumberedtitleTextImage = function NumberedtitleTextImage(_ref2) {
  var bgColor = _ref2.bgColor,
    titleNumber = _ref2.titleNumber,
    title = _ref2.title,
    description = _ref2.description,
    imageTitle = _ref2.imageTitle,
    imageUrl = _ref2.imageUrl,
    imageDescription = _ref2.imageDescription;
  var theme = useTheme();
  var classes = useStyles();
  var _window = window,
    width = _window.innerWidth;
  var _useBreakpoints = useBreakpoints(),
    isExtraSmallScreen = _useBreakpoints.isExtraSmallScreen,
    isSmallScreen = _useBreakpoints.isSmallScreen;
  return /*#__PURE__*/React__default.createElement(Box, {
    className: classes.wrapper,
    bgcolor: bgColor
  }, /*#__PURE__*/React__default.createElement(Box, {
    maxWidth: theme.breakpoints.width("lg"),
    margin: "auto"
  }, /*#__PURE__*/React__default.createElement(Box, {
    width: "100%",
    pl: isExtraSmallScreen() ? 5.625 : 0,
    pr: isExtraSmallScreen() ? 2 : 0,
    pt: 1.5
  }, /*#__PURE__*/React__default.createElement(Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: !isExtraSmallScreen() && !isSmallScreen() ? "space-between" : "center"
  }, /*#__PURE__*/React__default.createElement(Box, {
    mt: isExtraSmallScreen() || isSmallScreen() ? 8 : 0,
    className: classes.item,
    maxWidth: 455,
    ml: !isExtraSmallScreen() ? 5.625 : 0,
    mr: !isExtraSmallScreen() ? 2 : 0
  }, /*#__PURE__*/React__default.createElement(Box, null, /*#__PURE__*/React__default.createElement(_StepIndicator, {
    index: titleNumber,
    className: classes.stepIndicator
  }), /*#__PURE__*/React__default.createElement(Typography, {
    variant: "h3",
    component: "h2",
    className: classes.title
  }, title)), description && /*#__PURE__*/React__default.createElement(Box, {
    mt: 3
  }, /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body1",
    component: "div"
  }, /*#__PURE__*/React__default.createElement(CustomRichTextFromMarkdown, {
    markdownString: description
  })))), !isSmallScreen() && !isExtraSmallScreen() && imageUrl && /*#__PURE__*/React__default.createElement(Box, {
    className: classes.item,
    display: "flex",
    flexDirection: "column"
  }, imageUrl && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(LazyLoadImage, {
    src: retrieveContentfulImage(imageUrl, width > 1280 ? {
      width: 640
    } : {
      width: width / 2
    }),
    className: classes.image,
    alt: imageTitle || ""
  }), imageDescription && /*#__PURE__*/React__default.createElement(Typography, {
    variant: "body2",
    align: "center",
    className: classes.imageTitle
  }, imageDescription)))))));
};
NumberedtitleTextImage.propTypes = {
  bgColor: PropTypes__default.string,
  titleNumber: PropTypes__default.string,
  title: PropTypes__default.string,
  description: PropTypes__default.string,
  imageUrl: PropTypes__default.string,
  imageTitle: PropTypes__default.string,
  imageDescription: PropTypes__default.string
};

export { NumberedtitleTextImage as default };
//# sourceMappingURL=NumberedTitleTextImage.js.map
